import { Category } from '@/model/category';

export function useCategory() {
  function getIconUrl(category: Category) {
    return new URL(
      `/src/assets/img/services-categories/${category.icon}.svg`,
      import.meta.url,
    ).href;
  }

  return {
    getIconUrl,
  };
}
